import './resizeObserverPatch'
import React from 'react'
import { createRoot } from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.css'
import './index.css'
import App from './App'

// Suppress noisy ResizeObserver loop warnings as early as possible in dev
(function installResizeObserverWarningSuppressor() {
    const matches = (text) => (
        text.includes('ResizeObserver loop completed with undelivered notifications') ||
        text.includes('ResizeObserver loop limit exceeded')
    );
    const shouldSuppress = (arg) => {
        if (!arg) return false;
        if (typeof arg === 'string') return matches(arg);
        const msg = (arg && ((arg.message || arg.toString) && arg.toString())) || '';
        return typeof msg === 'string' && matches(msg);
    };

    const originalError = console.error;
    const originalWarn = console.warn;
    console.error = (...args) => {
        if (shouldSuppress(args[0])) return;
        originalError.apply(console, args);
    };
    console.warn = (...args) => {
        if (shouldSuppress(args[0])) return;
        originalWarn.apply(console, args);
    };

    window.addEventListener('error', (event) => {
        const target = event?.error || event;
        if (shouldSuppress(target) || shouldSuppress(event?.message)) {
            if (typeof event.preventDefault === 'function') event.preventDefault();
            if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
            return false;
        }
        return undefined;
    });
})();

createRoot(document.getElementById('root')).render(<App />)
